<tt-page *ngIf="!!document" class="height-full">
    <tt-tabs [(ttSelectedId)]="selectedView">
        <tt-tab ttId="p" ttLabel="docarc_show"></tt-tab>
        <tt-tab ttId="i" ttLabel="docarc_info"></tt-tab>
    </tt-tabs>

    <tt-document-viewer-legacy *ngIf="selectedView === 'p'" class="flex-1" [ttModel]="document" ttShowDocument="true"></tt-document-viewer-legacy>

    <tt-card *ngIf="selectedView === 'i'" class="col-xs-12 col-md-3 sp-0">
        <tt-input ttLabel="docarc_keyno" [ttModel]="document.docarc_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="cust_no" [ttModel]="document.cust_no" ttReadonly></tt-input>
        <tt-input ttLabel="project_keyno" [ttModel]="document.project_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="projectprosess_keyno" [ttModel]="document.projectprosess_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="docfilename" [ttModel]="document.docfilename" ttReadonly></tt-input>
        <tt-input ttLabel="doctitle" [(ttModel)]="document.doctitle"></tt-input>
        <tt-input ttLabel="oleapplication_id" [ttModel]="document.oleapplication_id" ttReadonly></tt-input>
        <tt-input ttLabel="reg_by_portal_user_keyno" [ttModel]="document.reg_by_portal_user_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="latitude" [ttModel]="document.latitude" ttReadonly></tt-input>
        <tt-input ttLabel="longitude" [ttModel]="document.longitude" ttReadonly></tt-input>
        <tt-input ttLabel="altitude" [ttModel]="document.altitude" ttReadonly></tt-input>
        <tt-input ttLabel="filesize" [ttModel]="document.filesize" ttReadonly></tt-input>
        <tt-select ttLabel="doccategory" [(ttModel)]="document.doccategory_keyno" [ttData]="documentCategories" ttDataId="doccategory_keyno" ttDataName="doccategory_name"></tt-select>
        <tt-button *ngIf="canShowDocument" ttText="show" ttIcon="fad fa-external-link-alt" (ttClick)="openDocument()"></tt-button>
        <tt-button ttText="download" ttIcon="fad fa-file-download" (ttClick)="downloadDocument()"></tt-button>
        <tt-button-save ttText="save" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
        <tt-button ttText="delete" ttIcon="fad fa-trash" ttType="danger" (ttClick)="delete()" [ttLoading]="deleting"></tt-button>
    </tt-card>
</tt-page>
